import React from 'react';

export interface OutsideClickWrapperProps {
	children?: React.ReactNode | ((props: unknown) => React.ReactNode);
	className?: string;
	id?: string;
	onClick?: (event: MouseEvent) => void;
	onClickOutside?: ((event: MouseEvent) => void) | undefined;
}

export class OutsideClickWrapper extends React.Component<OutsideClickWrapperProps> {
	componentDidMount(): void {
		document.addEventListener('mousedown', this.documentClick);
		document.addEventListener('touchstart', this.documentClick);
	}

	componentWillUnmount(): void {
		document.removeEventListener('mousedown', this.documentClick);
		document.removeEventListener('touchstart', this.documentClick);
	}

	clickCaptured = false;

	documentClick = (): void => {
		const { onClickOutside } = this.props;

		if (!this.clickCaptured && onClickOutside) {
			const mouseUpHandler = (event: MouseEvent) => {
				onClickOutside(event);

				document.removeEventListener('mouseup', mouseUpHandler);
				document.removeEventListener('touchend', mouseUpHandler);
			};

			document.addEventListener('mouseup', mouseUpHandler);
			document.addEventListener('touchend', mouseUpHandler);
		}

		this.clickCaptured = false;
	};

	innerClick = (): void => {
		this.clickCaptured = true;
	};

	render(): React.ReactNode {
		const { className, onClick, onClickOutside, ...rest } = this.props;

		const props = {
			...rest,
			className,
			onClick,
			onMouseDown: this.innerClick,
			onTouchStart: this.innerClick
		};

		if (typeof this.props.children === 'function') {
			return this.props.children(props);
		}

		return React.createElement('div', props, this.props.children);
	}
}
